<template>
  <div :class="['lr-modal', {'hide': !show}]">
    <div class="lr-box pi-box">
      <div class="pi-header">Pickup Instruction</div>
      <div class="direction">{{ directions }}</div>
      <div v-if="zones.length > 1" class="pi-field">
        <label>Choose a pickup zone</label>
        <select v-model="zoneIndex">
          <option v-for="(x, i) in zones" :key="i" :value="i">{{ x.name }}</option>
        </select>
      </div>
      <div v-if="zones.length && zones[zoneIndex].locations.length" class="pi-field">
        <label>Choose a pickup location</label>
        <select v-model="locationIndex">
           <option v-for="(x, i) in zones[zoneIndex].locations" :key="i" :value="i">{{ x.name }}</option>
         </select>
      </div>
      <div class="pi-action d-flex justify-space-between">
        <div class="op-btn btn-md btn-block btn-secondary" @click="show = false">Cancel</div>
        <div class="op-btn btn-md btn-block btn-success" @click="updatePickup">Select</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pickup-instruction',
  data () {
    return {
      directions: '',
      zones: [],
      zoneIndex: 0,
      locationIndex: 0
    }
  },
  computed: {
    rsvp () { return this.$store.state.reservation },
    pickup () { return this.rsvp.leg1.pickup },
    venue () { return this.rsvp.venue },
    show: {
      get () { return this.venue.show },
      set (x) {
        this.$store.commit('reservation/setVenueData', {show: x})
      }
    }
  },
  methods: {
    getDefault () {
      let self = this
      if (!self.venue.list.length || !self.rsvp.leg1.selectedService) {
        console.log('empty venue or no selected service')
        self.$emit('next')
        return
      }

      let data = self.venue.list.find(x => x.lat === self.pickup.lat && x.lng === self.pickup.lng)
      if (!data) {
        console.log('cannot find venue')
        self.$emit('next')
        return
      }

      let selectedService = self.rsvp.leg1.selectedService.slice(1)
      if (selectedService === 'lyft_easy_step_in' || selectedService === 'lyft_priority_pickup') {
        selectedService = 'lyft'
      }

      data.zones.forEach(x => {
        let locations = []
        x.locations.forEach(y => {
          if (!y.disabled.includes(selectedService)) locations.push(y)
        })
        if (locations.length) {
          self.zones.push({
            name: x.name,
            directions: x.directions,
            locations: locations
          })
        }
      })
      if (!self.zones.length) {
        console.log('selected service is not allowed in any locations')
        self.$emit('next')
        return
      }
      self.directions = self.zones[0].locations[0].directions
    },
    updatePickup () {
      let self = this
      let pickupCopy = JSON.parse(JSON.stringify(self.pickup))
      self.$store.commit('reservation/setVenueData', {
        lastCoords: `${self.pickup.lat},${self.pickup.lng}`,
        origPickupData: pickupCopy,
        selected: {
          service: self.rsvp.leg1.selectedService,
          zone: self.zoneIndex,
          location: self.locationIndex
        }
      })

      let tmpPickup = JSON.parse(JSON.stringify(self.pickup))
      let data = self.venue.list.find(x => x.lat === self.pickup.lat && x.lng === self.pickup.lng)
      setTimeout(() => {
        tmpPickup.title = data.name + ', ' + self.zones[self.zoneIndex].name + ' ' + self.zones[self.zoneIndex].locations[self.locationIndex].name
        tmpPickup.address1 = data.name
        tmpPickup.address2 = self.zones[self.zoneIndex].name + ' ' + self.zones[self.zoneIndex].locations[self.locationIndex].name
        tmpPickup.lat = self.zones[self.zoneIndex].locations[self.locationIndex].lat
        tmpPickup.lng = self.zones[self.zoneIndex].locations[self.locationIndex].lng
        self.$store.commit('reservation/setPickup', {
          leg: 'leg1',
          value: tmpPickup
        })
        self.show = false
        self.$emit('next')
      }, 50)
    }
  },
  watch: {
    show (x) {
      let self = this
      if (x) {
        if (this.venue.lastCoords === `${this.pickup.lat},${this.pickup.lng}` && this.venue.selected.service === this.rsvp.leg1.selectedService) {
          this.zoneIndex = this.venue.selected.zone
          setTimeout(() => {
            self.locationIndex = this.venue.selected.location
            self.getDefault()
          }, 50)
          return
        }
        this.zones = []
        this.directions = ''
        this.zoneIndex = 0
        this.locationIndex = 0
        this.getDefault()
      }
    },
    zoneIndex (x) {
      this.locationIndex = 0
      if (!this.zones.length) {
        this.directions = ''
        return
      }
      this.directions = this.zones[x].locations[this.locationIndex].directions
    },
    locationIndex (x) {
      if (!this.zones.length) {
        this.directions = ''
        return
      }
      this.directions = this.zones[this.zoneIndex].locations[x].directions
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.lr-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  display: flex;
  justify-content: center!important;
  align-items: center!important;
  -webkit-transition: all 0.05s ease;
  -moz-transition: all 0.05s ease;
  -o-transition: all 0.05s ease;
  transition: all 0.05s ease;

  .lr-box {
    background: #fff;
    padding: 20px;
    border-radius: 6px;
    box-shadow: 3px 3px 2px rgba(0,0,0, .3);
    text-align: center;
    min-width: 400px;
    max-width: 500px;
    -webkit-transition: all 0.1s ease;
    -moz-transition: all 0.1s ease;
    -o-transition: all 0.1s ease;
    transition: all 0.1s ease;
  }
  &.hide {
    z-index: -1;
    opacity: 0;
    display: none !important;

    .lr-box{
      transform: scale(90%) translateY(30px);
    }
  }
}

.pi-box{
  .pi-header{
    font-size: 24px;
    font-weight: 600;
    letter-spacing: .6px;
    margin-bottom: 20px;
  }
  .direction{
    text-align: left;
    line-height: 1.3;
    letter-spacing: .6px;
    margin-bottom: 25px;
  }
  .pi-field{
    margin-bottom: 10px;
    text-align: left;

    label{
      letter-spacing: .7px;
      font-size: 15px;
      color: #777;
      display: block;
      margin-bottom: 5px;
      line-height: 1;
    }
  }
  select{
    padding: 5px;
    font-size: 16px;
    letter-spacing: .6px;
    background: #fafafa;
  }
  .pi-action{
    margin-top: 30px;
    gap: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// PickupInstruction.vue?1524853a